import styled from "styled-components";
import IUMRSNavBar from "../iumrs-icam25/IUMRSNavbar";
import { ICAMNavroute } from "../../../utils/ICAMnavroute";
import { MapPin, Calendar } from "lucide-react";
import Navbar from "../../Navbar";
import FooterSection from "../../FooterSection";
import WorkshopPageContent from "./WorkshopPageContent";
import WorkshopHero from "./WorkshopHero";
import heroImage1 from "../../../assets/images/workshop2026/heroImage1.jpg"
import heroImage2 from '../../../assets/images/workshop2026/heroImage2.jpg'
import heroImage3 from '../../../assets/images/workshop2026/heroImage3.jpg'
import heroImage4 from '../../../assets/images/workshop2026/heroImage4.jpg'
import { dec2026WorkshopSections } from "../../../utils/dec2026workshopsection";


const DecWorkshop2026 = () => {

    const slideShow = [ heroImage1, heroImage2, heroImage3, heroImage4]

    return(
        <Container>
            <Navbar />
            <WorkshopHero
                images={slideShow}
                titleLines={["ML & Computational", "Materials Modelling"]}
                accentLine="& Simulation Workshop"
                meta={[
                    { icon: Calendar, label: "2 – 4 December 2026" },
                    { icon: MapPin, label: "Toyota Ghana – UG Engineering Centre, Legon" },
                ]}
                primaryCta={{ label: "Register Now", to: "/amrs-dec-2026-workshop/register" }}
                secondaryCta={{
                    label: "Pay",
                    onClick: () => window.location.href = "/event/payment-initializer",
                }}/>
            
            <WorkshopPageContent sections={dec2026WorkshopSections} />
            <FooterSection />

        </Container>
    )
}

const Container = styled.div`
    background : 'blue';
    height : 120vh;
`
export default DecWorkshop2026;

